var map = {
	"./资讯1.png": 4670,
	"./资讯10.png": 4171,
	"./资讯11.png": 1317,
	"./资讯12.jpg": 4077,
	"./资讯13.jpg": 1860,
	"./资讯14.jpg": 9491,
	"./资讯15.jpg": 3204,
	"./资讯16.png": 6031,
	"./资讯17.png": 4615,
	"./资讯18.png": 4384,
	"./资讯19.jpg": 5012,
	"./资讯2.png": 466,
	"./资讯20.png": 1885,
	"./资讯21.png": 6007,
	"./资讯22.png": 1585,
	"./资讯23.png": 9847,
	"./资讯24.png": 2947,
	"./资讯25.png": 7510,
	"./资讯26.jpg": 908,
	"./资讯27.png": 6921,
	"./资讯28.jpg": 7203,
	"./资讯29.png": 8541,
	"./资讯3.jpg": 9323,
	"./资讯30.jpg": 2971,
	"./资讯31.png": 2953,
	"./资讯32.png": 3085,
	"./资讯33.jpg": 9464,
	"./资讯34.png": 7236,
	"./资讯35.png": 7729,
	"./资讯36.jpg": 2617,
	"./资讯37.jpg": 4911,
	"./资讯38.png": 5827,
	"./资讯39.png": 8236,
	"./资讯4.png": 6765,
	"./资讯40.jpg": 778,
	"./资讯41.jpg": 4295,
	"./资讯42.jpg": 8677,
	"./资讯43.jpg": 2378,
	"./资讯44.png": 6939,
	"./资讯45.jpg": 4407,
	"./资讯46.png": 7961,
	"./资讯47.png": 5210,
	"./资讯48.png": 2444,
	"./资讯49.jpg": 8821,
	"./资讯5.png": 757,
	"./资讯50.png": 1850,
	"./资讯51.png": 7402,
	"./资讯52.jpg": 5520,
	"./资讯53.jpg": 7102,
	"./资讯54.png": 9656,
	"./资讯55.jpg": 1324,
	"./资讯56.png": 8746,
	"./资讯57.png": 7798,
	"./资讯58.jpg": 3852,
	"./资讯59.jpg": 192,
	"./资讯6.png": 5397,
	"./资讯60.png": 5466,
	"./资讯61.jpg": 1383,
	"./资讯62.jpg": 3021,
	"./资讯63.png": 9606,
	"./资讯64.jpg": 250,
	"./资讯65.jpg": 7045,
	"./资讯66.jpg": 9953,
	"./资讯67.png": 9360,
	"./资讯68.png": 7706,
	"./资讯69.png": 8383,
	"./资讯7.png": 1842,
	"./资讯70.png": 6486,
	"./资讯71.png": 5271,
	"./资讯72.png": 2101,
	"./资讯73.jpg": 4032,
	"./资讯74.png": 6505,
	"./资讯75.png": 7856,
	"./资讯76.png": 4960,
	"./资讯77.png": 4777,
	"./资讯78.png": 8417,
	"./资讯79.jpg": 5946,
	"./资讯8.png": 556,
	"./资讯80.jpg": 7981,
	"./资讯81.png": 6694,
	"./资讯82.png": 8406,
	"./资讯83.jpg": 3365,
	"./资讯84.png": 6879,
	"./资讯85.png": 9556,
	"./资讯86.jpg": 3866,
	"./资讯87.jpg": 6721,
	"./资讯88.webp": 2511,
	"./资讯89.webp": 6919,
	"./资讯9.jpg": 9117,
	"./资讯90.png": 9047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7056;